// utils/analytics.ts

declare global {
  interface Window {
    gtag?: (
      type: string,
      action: string,
      params: Record<string, unknown>,
    ) => void
  }
}

type GTagEvent = {
  action: string
  category: string
  label?: string
  value?: number
  tenant?: string
}

export function getTenantCurrent(): string {
  // Lógica para extrair o tenant do subdomínio
  if (typeof window !== 'undefined') {
    const hostname = window.location.hostname
    return hostname.split('.')[0]
  }
  return 'unknown'
}

export function sendEventAnalytics(event: GTagEvent) {
  if (window.gtag) {
    window.gtag('event', event.action, {
      event_category: event.category,
      event_label: event.label,
      value: event.value,
      tenant: event.tenant || getTenantCurrent(),
    })
  }
}
